<template>
    <div class="py-12 shadow-inner px-6">
        <div class="heading w-full text-center">
            <h1 class="text-green-dark text-3xl sm:text-4xl font-bold sm:leading-10 sm:py-10">Tutti i concorrenti</h1>
        </div>
        <div class="content w-full sm:w-3/4 text-left bg-white shadow-md rounded-lg mt-6 m-auto px-4 sm:px-16 py-6 sm:py-10">
            <h4 class="text-xs sm:text-base text-green-medium uppercase font-bold">Seleziona il codice di un concorrente per visualizzarne i materiali</h4>
            <div class="w-full text-center mt-10" v-if="!users.length">
                <loaderIco class="h-8 w-8 text-green-dark"/>
            </div>
            <table class="table-auto w-full mt-6">
                <tbody>
                    <tr v-for="user, i in users" class="border-b border-green-light">
                        <td class="w-full text-left py-2">
                            <svg :id="`chev${user.uid}`" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2 text-green-light inline-block transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                            </svg>
                            <span class="text-xs font-semibold py-2 uppercase cursor-pointer hover:underline" @click="toggleSelection(user)">{{ i + 1 }}.  CODICE UTENTE: #{{ user.uid.substring(0,6) }} - documenti caricati: {{ projDocsCount(user) }}</span>
                            <div :id="`docs${user.uid}`" class="hidden pl-6">
                                <div v-for="doc in getProjDocs(user)">
                                    <a class="text-sm py-2 uppercase" :href="doc.url" target="_blank"><downloadIco class="w-4 h-4 inline-block mr-2" />
                                        <span v-if="doc.type == 'proj1'">relazione illustrativa e tecnica</span>
                                        <span v-if="doc.type == 'proj2'">elaborato grafico n° 1</span>
                                        <span v-if="doc.type == 'proj3'">elaborato grafico n° 2</span>
                                    </a>
                                </div>
                                <div v-if="projDocsCount(user) == 0">
                                    <span class="text-xs py-2 uppercase">nessun documento caricato</span>
                                </div>
                            </div>
                        </td>
                        <td class="sm:w-64 justify-end flex items-center py-2">
                            <div class="text-green-dark text-sm mr-4 hidden sm:block">Seleziona vincitore</div>
                            <div class="toggle">
                                <label :for="user.uid" class="flex items-center cursor-pointer">
                                    <!-- toggle -->
                                    <div class="relative">
                                        <!-- input -->
                                        <input type="checkbox" :id="user.uid" class="sr-only" v-model="user.selected" @click="toggleUserSelection(user, $event)">
                                        <!-- line -->
                                        <div class="line block bg-gray-200 w-14 h-8 rounded-full"></div>
                                        <!-- dot -->
                                        <div class="dot absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition"></div>
                                    </div>
                                </label>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import eyeIco from '@/svg/eye.vue'
import downloadIco from '@/svg/download.vue'
import arrowRightIco from '@/svg/arrow-right.vue'
import checkIco from '@/svg/check.vue'
import loaderIco from '@/svg/loader.vue'
import { mapGetters } from 'vuex'
import { db } from '@/db'

export default {
    components: { eyeIco, downloadIco, arrowRightIco, checkIco, loaderIco },
    data() {
        return {
            users: []
        }
    },
    async mounted() {
        const snapshot = await db.collection('users').get();
        snapshot.forEach(doc => {            
            let data = doc.data()
            data.id = doc.id
            this.users.push(data)
        });
        console.log(this.users)
    },
    computed: {

    },
    methods: {
        toggleSelection(user) {            
            document.querySelector(`#chev${user.uid}`).classList.toggle('rotate-90')      
            document.querySelector(`#docs${user.uid}`).classList.toggle('hidden')                        
        },
        async toggleUserSelection(user, event) {
            console.log(event)
            await db.collection('users').doc(user.id).update({
                selected: event.target.checked
            })
        },
        projDocsCount(user) {
            let count = 0         
            if(user.docs && typeof user.docs == 'object')
                user.docs.map(doc => {
                    if(['proj1','proj2','proj3'].includes(doc.type)) count++
                })
            return count
        },
        getProjDocs(user) {
            let docs = []
            if(user.docs && typeof user.docs == 'object')
                user.docs.map(doc => {
                    if(['proj1','proj2','proj3'].includes(doc.type)) docs.push(doc)
                })
            console.log(user.id, docs)
            return docs
        }
    }
}
</script>